import React from 'react';
import { UUID } from 'types/shared/UUID';
import { NavigationItem } from '../../ui-toolkit/components/Navigation/NavigationItem';
import { clientOrderTabNavigation } from './clientOrderTabNavigation';

export const generateNavigationItems = (orderId: UUID) => {
  return Object.values(clientOrderTabNavigation).map((labelValue) => (
    <NavigationItem key={labelValue.label} to={labelValue.value(orderId)} text={labelValue.label} />
  ));
};
